import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import Table from '../../../../../components/Table';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { columnsHistory, sizePerPageList } from '../../../../../utils/tableColumns';
import { useSelector } from 'react-redux';
import { Loading } from 'react-loading-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { addFileToUnits, addTestMethod, addUnits, getTestMethods, getUnits, updateTestMethod, updateUnits, deleteUnits } from '../../../../../api/optimalimsapi';
import { FormInput, VerticalForm } from '../../../../../components';


const Units = () => {

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [editPopupData, setEditPopupData] = useState([]);
    const [deletePopupData, setDeletePopupData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showTestmethodModal, setShowTestmethodModal] = useState(false);

    const { user } = useSelector((state) => ({
        user: state.Auth.user,
    }));

    const { t } = useTranslation();

    useEffect(() => {
        getPaginationData();
    }, []);

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getPaginationData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getPaginationData(limit, value);
    };

    const getPaginationData = async (limits, pages) => {
        Loading();
        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;
        let request = {
            limit: limitNumber,
            page: pagesNumber,
        };

        let response = await getUnits(request);

        if (response && response.success == true && response.data) {
            let res = response.data;
            let rawList = Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : []);
            let dataEditDelete = rawList.map((d) => {
                return {
                    id: d._id,
                    units: d.units,
                    unitName: d.unit_name,
                   // testParameter: d.test_parameter,
                };
            });
            let reqData = dataEditDelete.map((d) => {
                return {
                    ...d,
                    view: (
                        <span>
                            <i
                                title="Edit"
                                onClick={() => openEditPopup(d, dataEditDelete)}
                                className="uil uil-pen "
                                style={{ cursor: 'pointer' }}></i>
                            <i
                                title="Delete"
                                onClick={() => openDeleteConfirm(d)}
                                className="uil uil-trash-alt ms-2"
                                style={{ cursor: 'pointer' }}></i>
                        </span>
                    ),
                };
            });
            setPageNumber(res.currentPage || 1);
            setPageCount(res.totalPages || 1);
            setData(reqData);
            setTotalCount(res.totalItems || res.totalCount || rawList.length);
        } else {
            setData([]);
        }
        Loading();
    };

    async function openEditPopup(data, r) {
        const rowData = await filterData(data, r);
        setEditPopupData(rowData[0]);
        setShowModal(true);
    }

    function filterData(fulldata, r) {
        return r.filter((d) => d.id == fulldata.id);
    }

    const closeEditPopup = () => {
        setShowModal(false);
    };


    const closeDeleteConfirm = () => {
        setShowDeleteModal(false);
    };

    const openDeleteConfirm = async (data) => {
        setDeletePopupData(data);
        setShowDeleteModal(true);
    };

    //update data
    const onUpdateSubmit = async (formData) => {
        formData.userId = user._id;
        formData.id = editPopupData.id;
        Loading();
        let update = await updateUnits(formData);
        Loading();
        if (update) {
            getPaginationData();
            closeEditPopup();
            toast.success('Updated Data Successfully', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {
            toast.error('Please Try Again', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    async function deleteData(data) {
        Loading();
        const res = await deleteUnits(data);
        Loading();
        if (res && res.success) {
            getPaginationData();
            setShowDeleteModal(false);
            toast.success('Deleted data successfully', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {
            toast.error(res?.message || 'Please try again', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    }

    async function openAddUnitsPopup() {
        setShowTestmethodModal(true);
    }


    const onSubmitUnitsPopup = async (formData) => {
        Loading();
        let result = await addUnits(formData);
        if (result) {
            toast.success('Added Successfully', {
                position: toast.POSITION.TOP_RIGHT,
            });
            getPaginationData();
            closeAddTestmethodPopup();
        } else {
            toast.error('Please try again', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        Loading();
    };

    const closeAddTestmethodPopup = () => {
        setShowTestmethodModal(false);
    };



    const columns = [
        {
            Header: 'Units Symbol',
            accessor: 'units',
            sort: true,
        },
        {
            Header: 'Units',
            accessor: 'unitName',
            sort: true,
        },
        {
            Header: 'View',
            accessor: 'view',
            sort: true,
        }
    ];
    /*
         * handle form submission
         */
    const inputRef = useRef(null);

    const handleClick = () => {
        inputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }
        event.target.value = null;
        const fileExtension = fileObj.name.split('.').pop().toLowerCase();
        if (fileObj && (fileObj.type === 'text/csv' || fileExtension === 'xlsx' || fileExtension === 'xls')) {
            Loading();
            let result = await addFileToUnits(fileObj);
            if (result) {
                getPaginationData();
                toast.success('Added Successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error('Please Try Again', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            Loading();
        }
    };

    return (
        <>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box">
                        <h4 className="page-title">Units</h4>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Table
                                columns={columns}
                                data={data}
                                pageSize={limit}
                                pageCount={pageCount}
                                pageNumber={pageNumber}
                                totalCount={totalCount}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                                onPageChange={handlePageChange}
                                onPageClick={handlePageClick}
                                inputRef={inputRef}
                                handleFileChange={handleFileChange}
                                extraButtons={
                                    <>
                                        <Button className="me-2" onClick={handleClick}>
                                            <i className="mdi mdi-plus"></i> Import CSV / Excel
                                        </Button>
                                        <Button onClick={() => {
                                            openAddUnitsPopup();
                                        }}>
                                            <i className="mdi mdi-plus"></i> Add Units
                                        </Button>
                                    </>
                                }
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Modal show={showModal} dialogClassName="modal-dialog-centered" size="lg" backdrop="static"
                keyboard={false} onHide={closeEditPopup}>
                <Modal.Header onHide={closeEditPopup} className="modal-colored-header bg-primary ">
                    <h4 className="modal-title text-light">Edit </h4>
                    <h3 className="modal-title text-light" onClick={closeEditPopup} style={{ cursor: 'pointer' }}>
                        X
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    {' '}
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <VerticalForm
                                        defaultValues={editPopupData}
                                        onSubmit={onUpdateSubmit}>
                                        <FormInput
                                            label={t('Units Symbol')}
                                            type="text"
                                            mandatory="true"
                                            name="units"
                                            placeholder={t('Enter Units')}
                                            containerClass={'mb-3'}
                                        />
                                        <FormInput
                                            label={t('Units')}
                                            type="text"
                                            mandatory="true"
                                            name="unitName"
                                            placeholder={t('Enter Units')}
                                            containerClass={'mb-3'}
                                        />
                                        {/* <FormInput
                                            label={t('Test Parameter')}
                                            type="select"
                                            name="testParameter"
                                            multiple
                                            mandatory="true"
                                            placeholder={t('Select Test Parameter')}
                                            containerClass={'mb-3'}>
                                            <option value="">Select Test Parameter</option>
                                            <option value="one">One</option>
                                            <option value="two">Two</option>
                                        </FormInput> */}
                                        <Button variant="primary" type="submit">
                                            <i className="mdi mdi-login"></i> {t('Submit')}
                                        </Button>
                                    </VerticalForm>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showDeleteModal} dialogClassName="modal-dialog-centered" backdrop="static"
                keyboard={false} size="md" onHide={closeDeleteConfirm}>
                <Modal.Header onHide={closeDeleteConfirm} className="modal-colored-header bg-primary">
                    <h4 className="modal-title text-light">Delete </h4>
                    <h3 className="modal-title text-light" onClick={closeDeleteConfirm} style={{ cursor: 'pointer' }}>
                        X
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    {' '}
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <h4>Are you sure you want to delete this unit?</h4>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={() => {
                            deleteData(deletePopupData);
                        }}
                    >
                        Yes
                    </Button>
                    <Button variant="primary" onClick={closeDeleteConfirm}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showTestmethodModal} dialogClassName="modal-dialog-centered" size="lg" backdrop="static"
                keyboard={false} onHide={closeAddTestmethodPopup}>
                <Modal.Header onHide={closeAddTestmethodPopup} className="modal-colored-header bg-primary">
                    <h4 className="modal-title text-light">Add Units</h4>
                    <h3 className="modal-title text-light" onClick={closeAddTestmethodPopup} style={{ cursor: 'pointer' }}>
                        X
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <VerticalForm onSubmit={onSubmitUnitsPopup}>
                                        <FormInput
                                            label={t('Units Symbol')}
                                            type="text"
                                            mandatory="true"
                                            name="units"
                                            placeholder={t('Enter Units')}
                                            containerClass={'mb-3'}
                                        />
                                        <FormInput
                                            label={t('Units')}
                                            type="text"
                                            mandatory="true"
                                            name="unitName"
                                            placeholder={t('Enter Units')}
                                            containerClass={'mb-3'}
                                        />
                                        {/* <FormInput
                                            label={t('Test Parameter')}
                                            type="select"
                                           // name="testParameter"
                                            multiple
                                            mandatory="true"
                                            placeholder={t('Select Test Parameter')}
                                            containerClass={'mb-3'}>
                                            <option value="">Select Test Parameter</option>
                                            <option value="one">One</option>
                                            <option value="two">Two</option>
                                        </FormInput> */}
                                        <Button variant="primary" type="submit">
                                            <i className="mdi mdi-login"></i> {t('Submit')}
                                        </Button>
                                        <Button className="ms-3" variant="primary" onClick={closeAddTestmethodPopup}>
                                            <i class="mdi mdi-arrow-left-bold"></i> {t('Back')}
                                        </Button>
                                    </VerticalForm>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <ToastContainer />
        </>
    );
}

export default Units;